import { Link } from "react-router-dom";
import { Instagram, Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-cream border-t border-burgundy/10 py-16 md:py-24 px-6 md:px-12 lg:px-24">
      <div className="max-w-6xl mx-auto">
        {/* Main Footer Content */}
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-12 md:gap-8">
          
          {/* Brand */}
          <div className="md:flex-1">
            <Link to="/" className="text-burgundy text-xl md:text-2xl tracking-[0.15em] uppercase font-light block mb-3">
              Duet Dining
            </Link>
            <p className="text-burgundy/50 text-sm tracking-wide">
              Music. Food. Vibes.
            </p>
          </div>

          {/* Contact Info */}
          <div className="md:flex-1 md:text-center">
            <h3 className="text-sm tracking-[0.2em] uppercase mb-6 text-burgundy/60 font-medium">
              Contact
            </h3>
            <div className="space-y-3">
              <a
                href="mailto:dining.duet@gmail.com"
                data-testid="footer-email-link"
                className="flex md:justify-center items-center gap-3 text-burgundy/70 hover:text-burgundy transition-colors group"
              >
                <Mail className="w-4 h-4 group-hover:text-blue transition-colors" />
                <span className="text-sm">dining.duet@gmail.com</span>
              </a>
              <a
                href="tel:+31631046738"
                data-testid="footer-phone-link"
                className="flex md:justify-center items-center gap-3 text-burgundy/70 hover:text-burgundy transition-colors group"
              >
                <Phone className="w-4 h-4 group-hover:text-blue transition-colors" />
                <span className="text-sm">+31 6 31046738</span>
              </a>
            </div>
          </div>

          {/* Social */}
          <div className="md:flex-1 md:text-right">
            <h3 className="text-sm tracking-[0.2em] uppercase mb-6 text-burgundy/60 font-medium">
              Volg ons
            </h3>
            <div className="flex md:justify-end gap-4">
              <a
                href="https://www.instagram.com/duet.dining/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                className="w-10 h-10 border border-burgundy/20 flex items-center justify-center text-burgundy/60 hover:text-burgundy hover:border-burgundy transition-all duration-300"
              >
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-burgundy/10 mt-16 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-center">
            <p className="text-burgundy/40 text-xs tracking-wide">
              © {new Date().getFullYear()} Duet Dining. Alle rechten voorbehouden.
            </p>
            <Link 
              to="/offerte" 
              data-testid="footer-offerte-link"
              className="text-burgundy/40 text-xs tracking-wide hover:text-burgundy transition-colors"
            >
              Offerte aanvragen
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
